export const SCREEN_SIZE = {
  sm: 'sm',
  lg: 'lg',
};

export const TOOLTIP_OFFSET_Y_TO_ANCHOR_PIXELS = 12;
